/** Fetch a pricebook item's detail payload. */
export async function fetchPriceBookItemDetails(detailsEndpoint: string): Promise<PricebookItem> {
    const response = await fetch(detailsEndpoint)

    if (!response.ok) {
        throw new Error(`Request to ${detailsEndpoint} failed with status ${response.status}.`)
    }

    return (await response.json()) as PricebookItem
}
